"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBrandBusinessBodyToJSON = exports.AddBrandBusinessBodyFromJSONTyped = exports.AddBrandBusinessBodyFromJSON = void 0;
function AddBrandBusinessBodyFromJSON(json) {
    return AddBrandBusinessBodyFromJSONTyped(json, false);
}
exports.AddBrandBusinessBodyFromJSON = AddBrandBusinessBodyFromJSON;
function AddBrandBusinessBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brand': json['brand'],
        'business': json['business'],
    };
}
exports.AddBrandBusinessBodyFromJSONTyped = AddBrandBusinessBodyFromJSONTyped;
function AddBrandBusinessBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brand': value.brand,
        'business': value.business,
    };
}
exports.AddBrandBusinessBodyToJSON = AddBrandBusinessBodyToJSON;
